import type { EntityConfig } from '../types'

export const enrollmentEntity: EntityConfig = {
  id: 'enrollment',
  displayName: 'Enrollment',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'pending', label: 'Pending' },
      { value: 'suspended', label: 'Suspended' },
      { value: 'opted_out', label: 'Opted Out' },
    ],
    options: [
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'suspended', label: 'Suspended', color: 'error' },
      { value: 'opted_out', label: 'Opted Out', color: 'neutral' },
    ],
    mappings: {
      all: ['pending', 'active', 'suspended', 'opted_out'],
      active: ['active'],
      pending: ['pending'],
      suspended: ['suspended'],
      opted_out: ['opted_out'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    campaign: { type: 'string_array', urlKey: 'campaign' },
    channel: { type: 'string_array', urlKey: 'channel' },
    tier: { type: 'string_array', urlKey: 'tier' },
    enrolledDate: { type: 'date_range', urlKey: 'enrolledDate' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['status', 'campaign', 'channel', 'tier', 'enrolledDate'],
}
